<template>
  <div class="content d-flex align-items-center justify-content-center">
    <div class="spinner-border" role="status" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LoadingOverlay'
});
</script>

<style lang="scss" scoped>
.content {
  background-color: rgba(255, 255, 255, 1);
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
